import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(async (config) => {
  try {
    // Clerk exposes itself on window after ClerkProvider mounts
    const clerk = (window as { Clerk?: { session?: { getToken?: () => Promise<string | null> } } }).Clerk;
    const token = await clerk?.session?.getToken?.();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {
    // Not authenticated yet — request proceeds without auth header
  }
  return config;
});

export function extractAxiosDetail(err: unknown): string {
  if (
    err !== null &&
    typeof err === 'object' &&
    'response' in err &&
    (err as { response?: unknown }).response !== null &&
    typeof (err as { response?: unknown }).response === 'object'
  ) {
    const resp = (err as { response: { data?: unknown } }).response;
    if (resp && typeof resp.data === 'object' && resp.data !== null) {
      const detail = (resp.data as Record<string, unknown>).detail;
      if (typeof detail === 'string') return detail;
    }
  }
  return '';
}

export default api;
